import {
  GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST_FULFILLED,
  GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST,
  GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING,
  GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED,
  DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED,
  SELECT_DELIVERY_FUNCTION_NETWORK_INTERFACE,
  OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP,
  CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP,
  OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP,
  CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP,
  CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED,
  SET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LOADING,
  CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING,
  DeliveryFunctionNetworkInterfaceActionTypes,
  DeliveryFunctionNetworkInterfaceState,
} from './deliveryFunctionNetworkInterface.types';

export const initialState: DeliveryFunctionNetworkInterfaceState = {
  entities: [],
  single: null,
  selected: [],
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isEditPopupOpen: false,
    isLoading: false,
  },
};

export default function DeliveryFunctionNetworkInterfaceReducer(
  state = initialState,
  action: DeliveryFunctionNetworkInterfaceActionTypes,
): DeliveryFunctionNetworkInterfaceState {
  switch (action.type) {
    case GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_DELIVERY_FUNCTION_NETWORK_INTERFACE:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP:
      return {
        ...state,
        single: action.payload,
        createdId: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: true,
        },
      };

    case CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: false,
        },
      };

    case OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isEditPopupOpen: true,
        },
      };

    case CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isEditPopupOpen: false,
        },
      };

    case SET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
